module.exports = __webpack_public_path__ + "img/flag-australia.c700e59.svg";